'use client';
import { Container } from '@chakra-ui/react';
import React from 'react';

import { StickyElementWrapper } from '../../sticky-element-wrapper/sticky-element-wrapper';

import styles from './search-filters-wrapper.module.scss';

export const SearchFiltersWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <StickyElementWrapper
    className={styles.filters as string}
    stickyClassName={styles.filtersShadow}
  >
    <Container maxW={'1328px'} width={'100%'} px={0} position="relative">
      {children}
    </Container>
  </StickyElementWrapper>
);
